// extracted by mini-css-extract-plugin
module.exports = {"col":"Col_col__VX1Eg","col--noGutters":"Col_col--noGutters__PpR_e"};